import { useEffect, useState } from "react";

/** Slowly decreases available slots from `total` down to `floor`, once `started`. */
export function useDecreasingSlots(total: number, floor: number, started: boolean) {
  const [slots, setSlots] = useState(total);

  useEffect(() => {
    if (!started || slots <= floor) return;
    const delay = 4000 + Math.random() * 7000;
    const id = window.setTimeout(() => setSlots((s) => Math.max(floor, s - 1)), delay);
    return () => window.clearTimeout(id);
  }, [started, slots, floor]);

  return slots;
}
